import type { InvoiceEmailDetailResponse } from './types';

import { ENDPOINT } from '~/constants/endpoints';

import type { UUID } from '~/types/common';

import type { KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { zodInvoiceEmailDetailResponseSchema } from './validations';

/**
 * The HTML body is untrusted. Render it only in an iframe that blocks scripts.
 */
export async function fetchInvoiceEmail(
  emailId: UUID,
  options?: KyRequestOptions,
) {
  return vestigasApi
    .get(ENDPOINT.INVOICE_EMAIL.GET_DETAIL(emailId), {
      ...options,
      validate: {
        ...options?.validate,
        response: zodInvoiceEmailDetailResponseSchema,
      },
    })
    .json<InvoiceEmailDetailResponse>();
}
